import ProgressCircle from './ProgressCircle';
import './styles/Subject.scss'

export default function Subject({ img, progress, title, onClick, commingSoon = false }: any) {
    return (
        <div onClick={commingSoon ? undefined : onClick} className={"subject " + (commingSoon ? "disabled" : "")}>
            <div className="thumb">
                <img src={img} alt="" />
            </div>

            <h1>{title}</h1>

            <ProgressCircle value={progress} />

            <span className="state">{commingSoon ? "Připravujeme" : progress + " % hotovo"}</span>

            {commingSoon && <div className="commingSoon">Připravujeme</div>}
        </div>
    );
}
